import RoutesMixin from './routes'

export default {
  mixins: [RoutesMixin],

  methods: {
    routesAllowedBf () {
      return this.isHome() ||
        this.isListPage() ||
        this.isConfigurePage() ||
        this.isConfirmationPage() ||
        this.isOldPaymentPage() ||
        this.isBlackFridayPage() ||
        this.isBuenfinPage()
    },

    isDarkEvent () {
      return this.isBf() || this.isBuenfin() || this.isCyberSale()
    },

    isPromotionalEventOnPages () {
      return this.isDarkEvent() && this.routesAllowedBf()
    },

    isBf () {
      const buenFin = /^(black_friday)(_.*)?$/

      return buenFin.test(this.$store.getters.getCustomEvent)
    },

    isBuenfin () {
      const buenFin = /^(buen_fin)(_.*)?$/

      return buenFin.test(this.$store.getters.getCustomEvent)
    },

    isYellowWeek () {
      const yellowWeek = /^(yellow_week)(_.*)?$/

      return yellowWeek.test(this.$store.getters.getCustomEvent)
    },

    isCyberSale () {
      const cyberSale = /^(cyber_sale)(_.*)?$/

      return cyberSale.test(this.$store.getters.getCustomEvent)
    },

    isWorldCup () {
      const worldCup = /^(world_cup)(_.*)?$/

      return worldCup.test(this.$store.getters.getCustomEvent)
    },

    isPromotionalEvent () {
      return this.isBf() || this.isBuenfin() || this.isYellowWeek() || this.isCyberSale()
    },

    getPromotionHeader () {
      if (this.isBf()) {
        return { img: 'images/blackfriday-2025/seal-promo.svg', alt: 'Black Friday' }
      }

      if (this.isBuenfin()) {
        return { img: 'images/buenfin-2025/seal-promo.svg', alt: 'Buen Fin' }
      }

      if (this.isYellowWeek()) {
        return { img: 'images/blackfriday-2024/seal-promo-yellowweek.svg', alt: 'Yellow Week' }
      }

      if (this.isCyberSale()) {
        return { img: 'images/cybersale-2025/seal-promo.svg', alt: 'Cyber Sale' }
      }

      if (this.isWorldCup()) {
        return { img: 'images/worldcup/icon-trophy.svg', alt: 'World Cup' }
      }

      return { img: 'images/rentday/seal-rentday-list.svg', alt: 'Rent Day' }
    },

    getSealHome () {
      if (this.isBf()) {
        return { img: 'images/blackfriday-2024/seal-bf.svg', alt: 'Black Friday' }
      }

      if (this.isBuenfin()) {
        return { img: 'images/blackfriday-2024/seal-promo-buenfin.svg', alt: 'Buen Fin' }
      }

      return { img: 'images/blackfriday-2024/seal-yw.svg', alt: 'Yellow Week' }
    }
  }
}
